/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import {
  applyUnblockAccountOptimistic,
  isContentBlockingAffectedQuery,
  reconcileContentBlockingResponse,
} from '../../helpers/content-blocking.js';
import type { UnblockAccountResponse, UnblockAccountVars } from '../openapi-types.gen.js';

export type { UnblockAccountResponse, UnblockAccountVars } from '../openapi-types.gen.js';

export const useUnblockAccount = createMutationHook<UnblockAccountVars, UnblockAccountResponse, unknown>({
  specName: 'useUnblockAccount',
  path: '/v1/blocked-accounts/{userId}',
  method: 'DELETE',
  resolveUrl: (vars: UnblockAccountVars) => `/v1/blocked-accounts/${vars.userId}`,
  
  parseResponse: (raw: unknown): UnblockAccountResponse => raw as UnblockAccountResponse,
  optimistic: [
    {
      queryKey: [],
      predicate: isContentBlockingAffectedQuery,
      
      apply: (prev: unknown, vars: UnblockAccountVars, queryKey: readonly unknown[]) =>
        applyUnblockAccountOptimistic(prev, vars, queryKey),
    }, {
    queryKey: ['blocked-accounts', 'detail'],
    apply: (prev: any, vars: UnblockAccountVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['blocked-accounts', 'list'],
    apply: (prev: any, vars: UnblockAccountVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"block","targetArg":"userId","active":false} as const,
  onSuccess: (response: UnblockAccountResponse, vars: UnblockAccountVars, queryClient) =>
    reconcileContentBlockingResponse(queryClient, response, vars),
});
